import { MessageBarType } from "@fluentui/react"

import { L10n } from "@encoway/l10n"

import { useAppDispatch, useAppSelector } from "../app/hooks"
import { addToast } from "../app/toastSlice"
import {
    selectVisualization,
    setSavedConfigurationCode,
    setVisualizationChanged
} from "../app/visualizationSlice"
import { TranslationConstants } from "../constants/translationConstants"

export const useSaveConfiguration = () => {
    const visualization = useAppSelector(selectVisualization)
    const dispatch = useAppDispatch()

    return async (callback?: (configurationCode: string) => void) => {
        visualization.saveState().then((state) => {
            const baseUrl = window.encoway.baseUrl
            // TODO: Change to axios
            fetch(`${baseUrl}/api/configuration/configurations/code`, {
                method: "POST",
                credentials: "include",
                body: JSON.stringify({
                    visualizationData: state
                })
            }).then(async (response) => {
                if (response.status === 201) {
                    const result = await response.json()
                    dispatch(setSavedConfigurationCode(result))
                    dispatch(setVisualizationChanged(false))
                    dispatch(
                        addToast({
                            message: L10n.format(
                                TranslationConstants.Notifications
                                    .SAVE_CONFIGURATION_SUCCESS
                            ),
                            type: MessageBarType.success,
                            duration: 6000
                        })
                    )

                    if (callback) {
                        callback(result)
                    }
                } else {
                    dispatch(
                        addToast({
                            message: L10n.format(
                                TranslationConstants.Notifications
                                    .SAVE_CONFIGURATION_ERROR
                            ),
                            type: MessageBarType.error,
                            duration: 6000
                        })
                    )
                }
            })
        })
    }
}
